import { createFileRoute } from '@tanstack/react-router';
import {
  OAuthCallbackFailed,
  completeOAuthCallback,
  oauthCallbackSearch,
  requireOAuthCallbackAccess,
} from '@/components/integrations-hub/oauth-callback';

// Slack redirects here with ?code&state (the redirect URL in the Slack app manifest).
export const Route = createFileRoute(
  '/_auth/_side-layout/integrations/slack/callback',
)({
  validateSearch: oauthCallbackSearch,
  beforeLoad: ({ context }) => requireOAuthCallbackAccess(context),
  loaderDeps: ({ search }) => search,
  loader: ({ deps, context }) =>
    completeOAuthCallback('slack', deps, context.queryClient),
  component: SlackCallbackPage,
});

function SlackCallbackPage() {
  const { failedReason } = Route.useLoaderData();
  return (
    <OAuthCallbackFailed integrationId="slack" failedReason={failedReason} />
  );
}
